import LumaAccessiblePanel from '../admin/CoworkFormPanel';
import {Dialog as LumaAccessibleDialog, DialogTitle as LumaAccessibleTitle} from '@headlessui/react';
// components/config-horas-regalo/DeleteConfigHoras.tsx
import React, { useState } from 'react';
import { Trash2, X } from 'lucide-react';
import { deleteHorasRegaloConfig, HorasRegaloConfig } from '../../services/horasRegaloConfig';

interface DeleteConfigHorasProps {
    isOpen: boolean;
    onClose: () => void;
    onDeleted: (deletedConfigId: number) => void;
    config: HorasRegaloConfig | null;
}

const DeleteConfigHoras: React.FC<DeleteConfigHorasProps> = ({ 
    isOpen, 
    onClose, 
    onDeleted,
    config 
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleDelete = async () => {
        if (!config) return;

        setLoading(true);
        setError('');

        try {
            await deleteHorasRegaloConfig(config.id);
            onDeleted(config.id);
            onClose();
        } catch (err: any) {
            /* Browser diagnostics omitted. */
            setError(err.response?.data?.message || 'Error al eliminar la configuración de horas de regalo');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen || !config) return null;

    return (
        <LumaAccessibleDialog open={isOpen} onClose={onClose} data-luma-overlay="true" className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <LumaAccessiblePanel data-luma-dialog="true" className="bg-white p-8 rounded-2xl w-full max-w-md border border-gray-100 shadow-2xl relative">
                <div className="flex justify-between items-start mb-6">
                    <LumaAccessibleTitle className="text-[20px] font-bold text-gray-900">Confirmar eliminación</LumaAccessibleTitle>
                    <button 
                        onClick={onClose} 
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {error && (
                    <p className="mb-6 text-red-500 text-sm">{error}</p>
                )}

                <p className="mb-8 text-gray-600">
                    ¿Estás seguro que deseas eliminar la configuración de horas de regalo para{' '}
                    <strong className="text-red-600">"{config.servicio_asociado_nombre} - {config.plan_config_info}"</strong>?
                    <br />
                    <span className="text-sm mt-2 block">
                        Esta acción no se puede deshacer.
                    </span>
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium text-[14px]"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={loading}
                        className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm flex items-center text-[14px]"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </LumaAccessiblePanel>
        </LumaAccessibleDialog>
    );
};

export default DeleteConfigHoras;
